export default {
	$accessibility: {
		archived: "Архивирован",
		present: "Доступен",
	},
	$accessModifier: {
		$description: {
			hidden_from_receiver: "Скрыт от получателя",
			hidden_from_sender: "Скрыт от отправителя",
			private: "Приватный",
			shared_with_custom: "Доступен по выбору",
			shared_with_everyone: "Доступен всем",
			shared_with_receiver: "Доступен получателю",
			shared_with_sender: "Доступен отправителю",
		},
	},
	$antProduct: {
		limitGBStorage: "{limit}ГБ памяти",
		limitMBStorage: "{limit}МБ памяти",
		limitUser: "{limit} пользователь",
		limitUsers: "{limit} пользователей",
		renewAtPricePerUnit: "Будет возобновлено за {currency}{price} за {unit}",
		unlimitedModule: "Неограниченный {module}",
		upToLimitModule: "До {limit} {module}",
	},
	$company: {
		address: "ул. Котекли Мах., Денизли Йолу Бул., Технопарк Ситеси Б Блок №4B, Внутр. №14, Ментеше / Мугла, ТУРЦИЯ",
		googleMapSrc:
			"https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d12715.523446137679!2d28.3731307!3d37.1793022!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14bf732687fd3eb1%3A0x2815d6eefcce8910!2sMu%C4%9Fla%20Teknopark!5e0!3m2!1sru!2str!4v1701805110461!5m2!1sru!2str",
		name: "Slush Software Inc.",
		phoneNumber: "+90 (555) 444-33-22",
		slogan:
			"Ускорьте свой бизнес с помощью Antrego. Управляйте процессами доставки цифровым, безопасным и простым способом.",
	},
	$cookieBanner: {
		accept: "Принять",
		decline: "Отклонить",
		message:
			"Мы используем файлы cookie и аналогичные технологии для аналитики и персонализированного контента. Нажимая «Принять», вы соглашаетесь на использование этих технологий.",
	},
	$country: {
		afghanistan: "Афганистан",
		aland: "Аландские острова",
		albania: "Албания",
		algeria: "Алжир",
		american_samoa: "Американское Самоа",
		andorra: "Андорра",
		angola: "Ангола",
		anguilla: "Ангилья",
		antarctica: "Антарктида",
		antigua_and_barbuda: "Антигуа и Барбуда",
		argentina: "Аргентина",
		armenia: "Армения",
		aruba: "Аруба",
		australia: "Австралия",
		austria: "Австрия",
		azerbaijan: "Азербайджан",
		bahamas: "Багамы",
		bahrain: "Бахрейн",
		bangladesh: "Бангладеш",
		barbados: "Барбадос",
		belarus: "Беларусь",
		belgium: "Бельгия",
		belize: "Белиз",
		benin: "Бенин",
		bermuda: "Бермуды",
		bhutan: "Бутан",
		bolivia: "Боливия",
		bonaire_sint_eustatius_and_saba: "Бонэйр, Синт-Эстатиус и Саба",
		bosnia_and_herzegovina: "Босния и Герцеговина",
		botswana: "Ботсвана",
		bouvet_island: "Остров Буве",
		brazil: "Бразилия",
		british_indian_ocean_territory: "Британская территория в Индийском океане",
		british_virgin_islands: "Британские Виргинские острова",
		brunei: "Бруней",
		bulgaria: "Болгария",
		burkina_faso: "Буркина-Фасо",
		burundi: "Бурунди",
		cabo_verde: "Кабо-Верде",
		cambodia: "Камбоджа",
		cameroon: "Камерун",
		canada: "Канада",
		cayman_islands: "Каймановы острова",
		central_african_republic: "Центральноафриканская Республика",
		chad: "Чад",
		chile: "Чили",
		china: "Китай",
		christmas_island: "Остров Рождества",
		cocos_islands: "Кокосовые острова",
		colombia: "Колумбия",
		comoros: "Коморы",
		congo_republic: "Республика Конго",
		cook_islands: "Острова Кука",
		costa_rica: "Коста-Рика",
		croatia: "Хорватия",
		cuba: "Куба",
		curacao: "Кюрасао",
		cyprus: "Кипр",
		czechia: "Чехия",
		denmark: "Дания",
		djibouti: "Джибути",
		dominica: "Доминика",
		dominican_republic: "Доминиканская Республика",
		dr_congo: "Демократическая Республика Конго",
		ecuador: "Эквадор",
		egypt: "Египет",
		el_salvador: "Сальвадор",
		equatorial_guinea: "Экваториальная Гвинея",
		eritrea: "Эритрея",
		estonia: "Эстония",
		eswatini: "Эсватини",
		ethiopia: "Эфиопия",
		falkland_islands: "Фолклендские острова",
		faroe_islands: "Фарерские острова",
		fiji: "Фиджи",
		finland: "Финляндия",
		france: "Франция",
		french_guiana: "Французская Гвиана",
		french_polynesia: "Французская Полинезия",
		french_southern_territories: "Французские Южные и Антарктические территории",
		gabon: "Габон",
		gambia: "Гамбия",
		georgia: "Грузия",
		germany: "Германия",
		ghana: "Гана",
		gibraltar: "Гибралтар",
		greece: "Греция",
		greenland: "Гренландия",
		grenada: "Гренада",
		guadeloupe: "Гваделупа",
		guam: "Гуам",
		guatemala: "Гватемала",
		guernsey: "Гернси",
		guinea: "Гвинея",
		guinea_bissau: "Гвинея-Бисау",
		guyana: "Гайана",
		haiti: "Гаити",
		heard_island_and_mcdonald_islands: "Остров Херд и острова Макдональд",
		honduras: "Гондурас",
		hong_kong: "Гонконг",
		hungary: "Венгрия",
		iceland: "Исландия",
		india: "Индия",
		indonesia: "Индонезия",
		iran: "Иран",
		iraq: "Ирак",
		ireland: "Ирландия",
		isle_of_man: "Остров Мэн",
		israel: "Израиль",
		italy: "Италия",
		ivory_coast: "Кот-д’Ивуар",
		jamaica: "Ямайка",
		japan: "Япония",
		jersey: "Джерси",
		jordan: "Иордания",
		kazakhstan: "Казахстан",
		kenya: "Кения",
		kiribati: "Кирибати",
		kosovo: "Косово",
		kuwait: "Кувейт",
		kyrgyzstan: "Киргизия",
		laos: "Лаос",
		latvia: "Латвия",
		lebanon: "Ливан",
		lesotho: "Лесото",
		liberia: "Либерия",
		libya: "Ливия",
		liechtenstein: "Лихтенштейн",
		lithuania: "Литва",
		luxembourg: "Люксембург",
		macao: "Макао",
		madagascar: "Мадагаскар",
		malawi: "Малави",
		malaysia: "Малайзия",
		maldives: "Мальдивы",
		mali: "Мали",
		malta: "Мальта",
		marshall_islands: "Маршалловы острова",
		martinique: "Мартиника",
		mauritania: "Мавритания",
		mauritius: "Маврикий",
		mayotte: "Майотта",
		mexico: "Мексика",
		micronesia: "Микронезия",
		moldova: "Молдова",
		monaco: "Монако",
		mongolia: "Монголия",
		montenegro: "Черногория",
		montserrat: "Монтсеррат",
		morocco: "Марокко",
		mozambique: "Мозамбик",
		myanmar: "Мьянма",
		namibia: "Намибия",
		nauru: "Науру",
		nepal: "Непал",
		netherlands: "Нидерланды",
		new_caledonia: "Новая Каледония",
		new_zealand: "Новая Зеландия",
		nicaragua: "Никарагуа",
		niger: "Нигер",
		nigeria: "Нигерия",
		niue: "Ниуэ",
		norfolk_island: "Остров Норфолк",
		north_korea: "Северная Корея",
		north_macedonia: "Северная Македония",
		northern_mariana_islands: "Северные Марианские острова",
		norway: "Норвегия",
		oman: "Оман",
		pakistan: "Пакистан",
		palau: "Палау",
		palestine: "Палестина",
		panama: "Панама",
		papua_new_guinea: "Папуа-Новая Гвинея",
		paraguay: "Парагвай",
		peru: "Перу",
		philippines: "Филиппины",
		pitcairn_islands: "Острова Питкэрн",
		poland: "Польша",
		portugal: "Португалия",
		puerto_rico: "Пуэрто-Рико",
		qatar: "Катар",
		reunion: "Реюньон",
		romania: "Румыния",
		russia: "Россия",
		rwanda: "Руанда",
		saint_barthelemy: "Сен-Бартелеми",
		saint_helena: "Остров Святой Елены",
		saint_lucia: "Сент-Люсия",
		saint_martin: "Сен-Мартен",
		saint_pierre_and_miquelon: "Сен-Пьер и Микелон",
		samoa: "Самоа",
		san_marino: "Сан-Марино",
		sao_tome_and_principe: "Сан-Томе и Принсипи",
		saudi_arabia: "Саудовская Аравия",
		senegal: "Сенегал",
		serbia: "Сербия",
		seychelles: "Сейшельские острова",
		sierra_leone: "Сьерра-Леоне",
		singapore: "Сингапур",
		sint_maarten: "Синт-Мартен",
		slovakia: "Словакия",
		slovenia: "Словения",
		solomon_islands: "Соломоновы острова",
		somalia: "Сомали",
		south_africa: "Южно-Африканская Республика",
		south_georgia_and_south_sandwich_islands: "Южная Георгия и Южные Сандвичевы острова",
		south_korea: "Южная Корея",
		south_sudan: "Южный Судан",
		spain: "Испания",
		sri_lanka: "Шри-Ланка",
		st_kitts_and_nevis: "Сент-Китс и Невис",
		st_vincent_and_grenadines: "Сент-Винсент и Гренадины",
		sudan: "Судан",
		suriname: "Суринам",
		svalbard_and_jan_mayen: "Шпицберген и Ян-Майен",
		sweden: "Швеция",
		switzerland: "Швейцария",
		syria: "Сирия",
		taiwan: "Тайвань",
		tajikistan: "Таджикистан",
		tanzania: "Танзания",
		thailand: "Таиланд",
		timor_leste: "Тимор-Лешти",
		togo: "Того",
		tokelau: "Токелау",
		tonga: "Тонга",
		trinidad_and_tobago: "Тринидад и Тобаго",
		tunisia: "Тунис",
		turkiye: "Турция",
		turkmenistan: "Туркменистан",
		turks_and_caicos_islands: "Теркс и Кайкос",
		tuvalu: "Тувалу",
		uganda: "Уганда",
		ukraine: "Украина",
		united_arab_emirates: "Объединенные Арабские Эмираты",
		united_kingdom: "Великобритания",
		united_states: "Соединенные Штаты",
		uruguay: "Уругвай",
		us_minor_outlying_islands: "Малые отдаленные острова США",
		us_virgin_islands: "Американские Виргинские острова",
		uzbekistan: "Узбекистан",
		vanuatu: "Вануату",
		vatican_city: "Ватикан",
		venezuela: "Венесуэла",
		vietnam: "Вьетнам",
		wallis_and_futuna: "Уоллис и Футуна",
		western_sahara: "Западная Сахара",
		yemen: "Йемен",
		zambia: "Замбия",
		zimbabwe: "Зимбабве",
	},
	$currency: {
		euro: "Евро",
		turkish_lira: "Турецкая лира",
		us_dollar: "Доллар США",
	},
	$documentManager: {
		message_1: 'Чтобы изменить шаблон, нажмите кнопку "Редактировать шаблон" для перехода в режим редактирования.',
		message_2: 'Вы можете изменить количество строк в списке, увеличивая или уменьшая "Количество строк".',
		message_3: 'Изменения, внесенные в поля содержимого, сразу отобразятся в разделе "Предварительный просмотр".',
		message_4: 'Чтобы создать PDF, нажмите кнопку "Действия с документом" для сохранения в формате PDF.',
		message_5: 'Чтобы получить доступ к документам позже, сохраните их через кнопку "Действия с документом".',
		message_6: "Данные, введенные в каждую ячейку таблицы, отобразятся в предварительном просмотре без изменений.",
		message_7: "Таблицу данных можно редактировать как таблицу Excel или электронную таблицу.",
	},
	$employeeType: {
		admin: "Администратор",
		default: "Обычный",
		exporter: "Экспортер",
		importer: "Импортер",
	},
	$format: {
		date: "DD.MM.YYYY",
		date_time: "DD.MM.YYYY HH:mm:ss",
		date_time_without_second: "DD.MM.YYYY HH:mm",
	},
	$home: {
		$noCompany: {
			create_company_subtitle: "Создайте свою компанию здесь.",
			create_company_title: "Хотите добавить свою компанию?",
			description: "Вы успешно вошли в систему. Теперь вам нужно присоединиться к компании или создать новую.",
			join_company_subtitle: "Введите свой код и присоединяйтесь к компании здесь.",
			join_company_title: "Хотите присоединиться к существующей компании?",
			title: "Добро пожаловать {name}",
		},
		$unauthorized: {
			description: "Контролируйте свои процессы экспорта и импорта с помощью Antrego",
			forget_password_subtitle: "Введите свою почту для сброса пароля.",
			sign_in_subtitle: "Войдите здесь",
			sign_in_title: "Уже есть аккаунт?",
			sign_up_subtitle: "Зарегистрируйтесь здесь",
			sign_up_title: "Хотите создать аккаунт?",
			title: "Добро пожаловать в Antrego",
		},
	},
	$invitationType: {
		company_partner: "Приглашение к коммерческому сотрудничеству",
		customs_partner: "Приглашение к сотрудничеству с таможней",
		employee: "Приглашение сотрудника",
	},
	$landing: {
		$benefits: {
			$detailPage: {
				hero_title: "Преобразуйте операции вашего бизнеса",
				hero_subtitle: "Преимущества платформы",
				hero_description:
					"Узнайте, как Antrego оптимизирует весь ваш логистический процесс — от управления запасами до отслеживания отправлений. Ощутите повышение эффективности, снижение затрат и улучшение сотрудничества по всей организации.",
				features_title: "Всесторонние преимущества платформы",
				feature_1_title: "Централизованная панель",
				feature_1_desc:
					"Доступ ко всем логистическим данным, отправлениям, запасам и документам из одного интуитивного интерфейса.",
				feature_2_title: "Повышенная точность данных",
				feature_2_desc:
					"Минимизируйте ошибки благодаря автоматическому вводу, валидации и синхронизации данных в реальном времени во всех модулях.",
				feature_3_title: "Экономия времени",
				feature_3_desc:
					"Ежедневно экономьте часы за счёт автоматизированных процессов, умных уведомлений и оптимизированных рабочих потоков.",
				feature_4_title: "Командное взаимодействие",
				feature_4_desc:
					"Обеспечьте бесшовное сотрудничество между внутренними командами, клиентами, поставщиками и логистическими партнёрами.",
				feature_5_title: "Снижение затрат",
				feature_5_desc:
					"Сократите операционные расходы благодаря повышению эффективности, меньшему количеству ошибок и оптимальному распределению ресурсов.",
				feature_6_title: "Масштабируемость",
				feature_6_desc: "Уверенно развивайте бизнес с платформой, которая легко масштабируется под ваши потребности.",
				benefits_title: "Почему Antrego?",
				benefit_1: "Полная видимость всей вашей цепочки поставок",
				benefit_2: "Безопасная облачная платформа с шифрованием корпоративного уровня",
				benefit_3: "Адаптивный дизайн для доступа на ходу",
				benefit_4: "Автоматические уведомления информируют всех участников",
				benefit_5: "Настраиваемые процессы, адаптирующиеся под ваш бизнес",
				benefit_6: "Выделенная команда поддержки для вашего успеха",
				workflow_title: "Как Antrego меняет ваши процессы",
				step_1_title: "Консолидируйте операции",
				step_1_desc:
					"Объедините управление запасами, отслеживание отправлений, работу с документами и коммуникации с клиентами в одной интегрированной платформе.",
				step_2_title: "Автоматизируйте рутину",
				step_2_desc:
					"Поручите Antrego повторяющиеся задачи — ввод данных, уведомления и обновления статусов — чтобы команда сосредоточилась на стратегической работе.",
				step_3_title: "Обеспечьте совместную работу в реальном времени",
				step_3_desc:
					"Делитесь информацией мгновенно со всеми участниками, чтобы у всех были актуальные обновления и документы.",
				step_4_title: "Принимайте решения на основе данных",
				step_4_desc:
					"Используйте расширенную аналитику и отчётность, чтобы выявлять тренды, оптимизировать процессы и обеспечивать непрерывные улучшения.",
				cta_title: "Готовы трансформировать логистику?",
				cta_button: "Начать бесплатно сегодня",
				cta_subtitle: "Без кредитной карты • Присоединились 500+ компаний",
			},
			benefits_title: "Преимущества платформы",
			business_process: "Ускоряет ваши бизнес-процессы.",
			control_title: "Контролируйте с помощью Antrego.",
			highlight_word: "контроль",
			risk_of_error: "Снижает риск ошибок.",
			text: "Antrego трансформирует логистические операции для экспортёров, импортёров, экспедиторов и производителей с помощью сквозных цифровых решений для управления запасами, отслеживания отправлений в реальном времени и автоматизации документооборота.",
			time_and_cost_savings: "Экономит время и деньги.",
		},
		$content: {
			$text: {
				0: "Отслеживайте все свои отправки в одном месте и контролируйте свои финансы с помощью динамической отчетности.",
				1: "Делитесь своими обновлениями в реальном времени с клиентами, чтобы улучшить качество обслуживания.",
				2: "Просматривайте и делитесь всеми документами, связанными с вашей отправкой, в одной системе.",
				3: "Легко контролируйте процесс, получая доступ к Antrego с любых устройств и мест.",
				4: "Храните все свои данные с использованием технологии шифрования SHA-256. Спите спокойно за безопасность.",
				5: "Участвуйте в совместном отслеживании со всеми участниками бизнес-процесса. Управляйте процессом более эффективно.",
			},
			$title: {
				0: "Сквозное управление отправлениями",
				1: "Коммуникации с клиентами в реальном времени",
				2: "Централизованное управление документами",
				3: "Облачный доступ из любой точки",
				4: "Безопасность корпоративного уровня",
				5: "Совместная работа многих сторон",
			},
			content_title: "Всё, что нужно, в одной платформе",
		},
		$home: {
			subtitle: "Управляйте запасами, отправлениями, документами и отслеживанием в одной мощной системе",
			text: "Экономьте до 40% рабочего времени благодаря автоматизированным процессам. Присоединяйтесь к 500+ компаниям, оптимизирующим логистику по всему миру.",
			title: "Полная логистическая платформа: от склада до доставки",
		},
		$lifecycle: {
			headline: "Процесс",
			info_button: "Получить информацию",
			lifecycle_texts: {
				0: "Загрузите дополнительные файлы для создания проформа-счета и мгновенно поделитесь им с клиентом.",
				1: "Введите детали отправки и добавьте документы. Уведомьте своего клиента и совместно управляйте всеми процессами отправки через один канал.",
				2: "Отслеживайте свое финансовое положение, связанное с импортом и экспортом, в режиме реального времени.",
			},
			lifecycle_titles: {
				0: "Войдите и создайте проформа-счет",
				1: "Создайте отправку",
				2: "Отслеживайте финансовую деятельность",
			},
			productivity_title: "Повышайте производительность и снижайте сложность и ошибки за 3 шага.",
			tracking_guide_title: "Руководство по легкому отслеживанию",
		},
		$logistics: {
			logistics_title: "Поддерживаемые виды логистики",
			solutions_title: "Правильное решение для каждого груза",
			text: "С Antrego, вашим цифровым партнером во всех видах транспорта, мы всегда рядом с вами во всех ваших глобальных движениях.",
		},
		$pdfEditor: {
			$detailPage: {
				hero_title: "Профессиональное создание PDF-документов",
				hero_subtitle: "Создавайте впечатляющие коммерческие документы за минуты",
				hero_description:
					"Интуитивный PDF-конструктор Antrego позволяет легко создавать, настраивать и генерировать профессиональные счета, проформы и коммерческие документы. Дизайнерские навыки не требуются.",
				features_title: "Всё для создания профессиональных документов",
				feature_1_title: "Редактор Drag & Drop",
				feature_1_desc:
					"Интуитивный интерфейс: добавляйте текст, изображения, логотипы и таблицы простым перетаскиванием. Технические навыки не нужны.",
				feature_2_title: "Пользовательские шаблоны",
				feature_2_desc:
					"Выбирайте из готовых шаблонов или создавайте собственные макеты бренда. Сохраняйте шаблоны для единообразного оформления.",
				feature_3_title: "Умные поля форм",
				feature_3_desc:
					"Автозаполнение данных клиента, товаров и цен. Прямое подключение к данным по отправлениям и складу.",
				feature_4_title: "Бренд-кастомизация",
				feature_4_desc:
					"Добавляйте логотип, выбирайте фирменные цвета, настраивайте шрифты и создавайте документы, точно отражающие стиль вашего бренда.",
				feature_5_title: "Экспорт в разных форматах",
				feature_5_desc:
					"Скачивайте PDF, печатайте напрямую или делитесь по email. Все документы профессионально оформлены и готовы к печати.",
				feature_6_title: "Контроль версий",
				feature_6_desc:
					"Отслеживайте правки, храните историю и возвращайтесь к прошлым версиям. Больше никаких потерянных итераций.",
				benefits_title: "Почему выбрать PDF-конструктор Antrego?",
				benefit_1: "Создавайте документы в 10 раз быстрее традиционных методов",
				benefit_2: "Единый фирменный стиль для всех коммерческих документов",
				benefit_3: "Меньше ошибок благодаря автозаполнению из данных отправлений",
				benefit_4: "Экономия времени с повторно используемыми шаблонами и умными формами",
				benefit_5: "Произведите впечатление на клиентов безупречными документами",
				benefit_6: "Доступ к документам в любом месте и с любого устройства",
				workflow_title: "Как проходит создание PDF",
				step_1_title: "Выберите шаблон",
				step_1_desc: "Выберите готовый шаблон или начните с чистого листа для собственного макета.",
				step_2_title: "Настройте содержимое",
				step_2_desc:
					"Перетаскивайте элементы, добавляйте логотип и фирменный стиль, автоматически заполняйте поля данными отправлений.",
				step_3_title: "Предпросмотр и правки",
				step_3_desc:
					"Просматривайте документ в реальном времени, корректируйте и добивайтесь идеального вида перед генерацией.",
				step_4_title: "Сгенерируйте и поделитесь",
				step_4_desc:
					"Скачайте PDF, отправьте клиентам по email или прикрепите к отправлениям. Сохраните шаблон для будущего.",
				cta_title: "Начните создавать профессиональные документы уже сегодня",
				cta_button: "Начать бесплатно",
				cta_subtitle: "Без кредитной карты • Начните за минуты",
			},
			description:
				"Наш PDF-редактор — это мощный инструмент, который делает создание и редактирование счетов более практичным. Экономьте время и предоставляйте профессионально выглядящие документы своим деловым партнерам.",
			features: {
				design: "Дизайн счетов: Добавьте ваш логотип, настройте цвета и формат счета.",
				edit: "Редактирование документов: Быстро редактируйте PDF, добавляйте или удаляйте текст.",
				shareSave: "Обмен и сохранение: Скачивайте, делитесь или сохраняйте созданные документы прямо на платформе.",
			},
			longTitle: "Быстрые и персонализированные счета с редактором PDF.",
			note: "Эта настройка позволяет пользователям визуально изучать функции и оценивать преимущества в письменной форме.",
			title: "Создавать счета так просто!",
		},
		$process: {
			comparison_subtitle: "Сравните традиционную и цифровую логистику",
			digital_future: "Откажитесь от традиционных методов и вступайте в цифровое будущее",
			digital_shipping: "Цифровое отслеживание отправок с помощью Antrego",
			digital_shipping_texts: {
				0: "Проформа-счета для полученных заказов создаются и отслеживаются легко через один канал.",
				1: "Проформа-счета отправляются, уведомления мгновенно поступают к клиенту, и они утверждаются через Antrego.",
				2: "Процессы обработки документов управляются через Antrego. Они не теряются, задержек не происходит, а вероятность ошибок минимизирована.",
				3: "Поставщики, клиенты и таможенные брокеры могут мгновенно видеть детали отправки и совместно их отслеживать.",
				4: "Финансовые отчеты автоматически создаются ежемесячно и ежегодно.",
			},
			question_title: "Как Antrego экономит вам 10+ часов в неделю",
			tracking_method: "Цифровизируйте свои методы отслеживания и ускорьте свои процессы.",
			traditional_shipping: "Традиционное отслеживание отправок",
			traditional_shipping_texts: {
				0: "Заказы собираются по электронной почте, сообщениям или телефону через разные каналы, что вызывает трудности с внутренним отслеживанием.",
				1: "Проформа-счет создается с помощью таких инструментов, как Excel, а процесс утверждения осуществляется вручную по электронной почте, WhatsApp или телефону.",
				2: "Ручные процессы обработки документов приводят к ошибкам и задержкам, вызывая потери времени и финансов.",
				3: "Нет общей платформы для поставщиков, клиентов и таможенных брокеров для отслеживания деталей отправки.",
				4: "Финансовые данные проверяются индивидуально после каждой отправки, что затрудняет отчетность.",
			},
		},
		$question: {
			$text: {
				0: "<p>Antrego — это комплексная платформа управления логистикой, помогающая компаниям отслеживать отправления, управлять запасами и взаимодействовать с клиентами в реальном времени. Она оцифровывает весь процесс цепочки поставок — от склада до доставки.</p>",
				1: "<p>Antrego упрощает логистику благодаря Лёгкому доступу с любого устройства, Защите данных корпоративного уровня с использованием шифрования SHA-256 и Совместному отслеживанию, которое информирует всех участников на протяжении всего пути отправления.</p>",
				2: "<p>Antrego поддерживает все основные виды транспорта: морские перевозки, авиагруз, автоперевозки и железнодорожную логистику. Мы работаем со всеми ведущими перевозчиками и судоходными линиями по всему миру.</p>",
				3: "<p>Antrego предлагает бесплатный тариф до 10 отправлений в месяц без необходимости карты. Премиум-тарифы начинаются от $99/месяц с безлимитными отправлениями; при оплате за год экономия 16%. Подробности — на странице цен.</p>",
				4: "<p>Мы сейчас разрабатываем API-доступ и интеграции с популярными логистическими и ERP-системами. Функции интеграции запланированы в будущих релизах. Свяжитесь с нами, чтобы узнать о дорожной карте и ближайших возможностях.</p>",
				5: "<p>Большинство компаний начинают работу в течение 24 часов. Базовая настройка занимает всего 5–10 минут: создайте аккаунт и добавьте данные компании. Наша команда онбординга поможет импортировать данные и настроить процессы.</p>",
			},
			$title: {
				0: "Что такое Antrego?",
				1: "Почему стоит использовать Antrego?",
				2: "Какие виды логистики поддерживает Antrego?",
				3: "Сколько стоит Antrego?",
				4: "Можно ли интегрировать Antrego с существующими системами?",
				5: "Сколько времени занимает внедрение Antrego?",
			},
			save_percentage: "Экономьте 16% ежемесячно",
			text: "Легко получайте всю информацию с помощью Antrego и обращайтесь к нам по любым другим вопросам.",
			title: "Быстро узнайте, что вас интересует",
		},
		$stockFeature: {
			$detailPage: {
				hero_title: "Трансформируйте управление запасами",
				hero_subtitle: "От запасов до продаж — управляйте всем жизненным циклом продукта цифрово",
				hero_description:
					"Функция управления запасами Antrego помогает экспортёрам и производителям эффективно управлять инвентарём, делиться каталогами с клиентами и ускорять продажи в одной интегрированной платформе.",
				features_title: "Мощные функции управления запасами",
				feature_1_title: "Централизованное управление инвентарём",
				feature_1_desc:
					"Управляйте всеми позициями со сквозной панели. Отслеживайте количества, партии, склады и детали товаров с лёгкостью.",
				feature_2_title: "Публичный каталог запасов",
				feature_2_desc:
					"Создайте публичную страницу каталога, чтобы демонстрировать доступные товары клиентам по всему миру. Делитесь инвентарём по простой ссылке.",
				feature_3_title: "Отслеживание партий",
				feature_3_desc:
					"Отслеживайте отдельные партии с подробной информацией: количества, габариты и пользовательские атрибуты для точного учёта.",
				feature_4_title: "Поддержка нескольких складов",
				feature_4_desc:
					"Организуйте запасы по нескольким складам и локациям. Знайте, где хранится каждый товар, для эффективной логистики.",
				feature_5_title: "Галерея изображений товара",
				feature_5_desc:
					"Загружайте несколько изображений на позицию, чтобы обеспечить наглядность для клиентов и команды.",
				feature_6_title: "Прямо в отправление",
				feature_6_desc:
					"Бесшовно конвертируйте позиции склада в отправления. Создавайте проформы и отгрузочные документы прямо из инвентаря.",
				benefits_title: "Почему Antrego для управления запасами?",
				benefit_1: "Увеличьте видимость товаров для покупателей по всему миру",
				benefit_2: "Сократите время на ручной учёт запасов",
				benefit_3: "Упростите переход от склада к продажам",
				benefit_4: "Предоставляйте клиентам данные по остаткам в реальном времени",
				benefit_5: "Поддержка 15+ языков для выхода на международные рынки",
				benefit_6: "Интеграция с системами отправлений и выставления счетов",
				workflow_title: "Как это работает",
				step_1_title: "Добавьте товары",
				step_1_desc: "Создавайте позиции с подробностями: характеристики, количества, склады и изображения.",
				step_2_title: "Поделитесь каталогом",
				step_2_desc: "Сгенерируйте публичную ссылку на каталог, доступный для просмотра в любое время.",
				step_3_title: "Получайте запросы",
				step_3_desc: "Клиенты просматривают доступные товары и связываются с вами по заказам и ценам.",
				step_4_title: "Конвертируйте в продажи",
				step_4_desc: "Легко создавайте проформы и отправления из позиций склада для выполнения заказов клиентов.",
				cta_title: "Готовы модернизировать управление запасами?",
				cta_button: "Начать бесплатно",
				cta_subtitle: "Без кредитной карты • Настройка за минуты",
			},
			access_potential_customers: "Быстро добирайтесь до потенциальных клиентов",
			desc: "Antrego, специально разработанный для экспортеров и производителей, ускоряет ваши процессы продаж и маркетинга. Развивайте свой бизнес с помощью управления запасами, совместного использования запасов с клиентами и управления отправками!",
			global_market: "Выходите на мировой рынок с поддержкой 15 разных языков",
			main_title: "Решение нового поколения для продаж и маркетинга",
			manage_stocks: "Управляйте своими запасами и делитесь ими мгновенно",
			speed_up_sales: "Ускорьте процессы продаж",
			title: "От склада к продажам",
		},
		$tracking: {
			$detailPage: {
				hero_title: "Отслеживание отправлений в реальном времени",
				hero_subtitle: "Контролируйте каждый контейнер на каждом этапе",
				hero_description:
					"Продвинутая система отслеживания Antrego обеспечивает полную видимость отправлений с обновлениями в реальном времени, автоматическими уведомлениями и подробной историей статусов. Больше никаких потерянных контейнеров.",
				features_title: "Полное решение для отслеживания",
				feature_1_title: "Живое отслеживание контейнеров",
				feature_1_desc:
					"Отслеживайте контейнеры в реальном времени с точными координатами и расчётом времени прибытия для каждого отправления.",
				feature_2_title: "Автоматические уведомления",
				feature_2_desc:
					"Мгновенные оповещения о ключевых этапах: погрузка, отправление, прибытие, таможенная очистка, доставка.",
				feature_3_title: "История статусов",
				feature_3_desc: "Полный журнал перемещений, изменений статусов и ключевых событий по каждому отправлению.",
				feature_4_title: "Видимость для всех участников",
				feature_4_desc:
					"Делитесь информацией об отслеживании с клиентами, поставщиками и брокерами. Все автоматически в курсе.",
				feature_5_title: "Управление документами",
				feature_5_desc:
					"Прикрепляйте и храните все документы по отправлениям — коносаменты, таможенные формы, сертификаты — в одном месте.",
				feature_6_title: "Оповещения о задержках",
				feature_6_desc:
					"Получайте проактивные уведомления о возможных задержках или проблемах, чтобы успеть принять меры.",
				benefits_title: "Почему отслеживание Antrego?",
				benefit_1: "Меньше запросов от клиентов благодаря самообслуживанию",
				benefit_2: "Предотвращайте дорогие задержки с проактивным мониторингом",
				benefit_3: "Повышайте удовлетворённость клиентов прозрачной коммуникацией",
				benefit_4: "Экономьте время за счёт автообновлений статусов для всех участников",
				benefit_5: "Минимизируйте риски благодаря видимости статуса в реальном времени",
				benefit_6: "Профессиональные страницы отслеживания укрепляют имидж бренда",
				workflow_title: "Как работает отслеживание",
				step_1_title: "Создайте отправление",
				step_1_desc: "Внесите данные: номера контейнеров, маршруты и ожидаемые даты.",
				step_2_title: "Автообновления",
				step_2_desc: "Система автоматически отслеживает контейнеры и обновляет статусы на каждом контрольном пункте.",
				step_3_title: "Уведомления участникам",
				step_3_desc: "Все стороны получают мгновенные уведомления о важных этапах и изменениях статусов.",
				step_4_title: "Подтверждение доставки",
				step_4_desc: "Получите финальное подтверждение доставки с полным комплектом документов и историей отправления.",
				cta_title: "Начните уверенно отслеживать отправления",
				cta_button: "Начать бесплатно",
				cta_subtitle: "Без кредитной карты • Начните отслеживание уже сегодня",
			},
			control_title: "Возьмите под контроль ваши отправления с Antrego.",
			real_time_alerts:
				"Оповещения в реальном времени: Получайте мгновенные уведомления и исчерпывающие обновления статуса каждого контейнера.",
			secure_data_handling:
				"Безопасное обращение с данными: Легко загружайте, делитесь или сохраняйте данные ваших отправлений прямо на платформе.",
			tracking_description:
				"Решение Antrego для отслеживания контейнеров предлагает быстрый и эффективный способ мониторинга ваших отправлений в режиме реального времени. Оставайтесь под контролем и впечатляйте партнеров подробными, профессиональными обновлениями.",
			tracking_title: "Отслеживайте ваши отправления с легкостью!",
		},
		cancel_anytime: "Отмените в любое время",
		customize_package:
			"Вы можете приобрести дополнительное хранилище и пользователей и настроить свой пакет в соответствии с вашими потребностями",
		free_features_1: "10 отправок",
		free_features_2: "100 МБ памяти",
		free_features_3: "Неограниченные коммерческие партнеры",
		free_features_4: "1 пользователь",
		free_plan: "Бесплатно",
		free_price: "$0",
		free_regeneration: "",
		free_title: "Ежемесячно",
		premium_annual_features_1: "20 пользователей",
		premium_annual_features_2: "100 партнеров",
		premium_annual_features_3: "1000 отправок",
		premium_annual_features_4: "1000 счетов-фактур",
		premium_annual_price: "$83.25",
		premium_annual_regeneration: "Будет возобновляться ежегодно за $999",
		premium_annual_title: "Ежегодно",
		premium_monthly_features_1: "Неограниченные отправки",
		premium_monthly_features_2: "Неограниченные коммерческие партнеры",
		premium_monthly_features_3: "2 ГБ памяти",
		premium_monthly_features_4: "3 пользователя",
		premium_monthly_price: "$99",
		premium_monthly_regeneration: "Будет возобновляться ежемесячно за $99",
		premium_monthly_title: "Ежемесячно",
		premium_plan: "Премиум-план",
		premium_plus_annual_features_1: "Неограниченные отправки",
		premium_plus_annual_features_2: "Неограниченные коммерческие партнеры",
		premium_plus_annual_features_3: "5 ГБ памяти",
		premium_plus_annual_features_4: "5 пользователей",
		premium_plus_annual_price: "$83.25",
		premium_plus_annual_regeneration: "Будет возобновляться ежегодно за $999",
		premium_plus_annual_title: "Ежегодно",
		premium_plus_monthly_features_1: "Неограниченные отправки",
		premium_plus_monthly_features_2: "Неограниченные коммерческие партнеры",
		premium_plus_monthly_features_3: "5 ГБ памяти",
		premium_plus_monthly_features_4: "5 пользователей",
		premium_plus_monthly_price: "$249",
		premium_plus_monthly_regeneration: "Будет возобновляться ежемесячно за $249",
		premium_plus_monthly_title: "Ежемесячно",
		premium_plus_plan: "Премиум Плюс",
		pricing_text: "Мы можем удовлетворить ваши потребности наилучшим образом без ущерба для вашего бюджета.",
		pricing_title: "Antrego гарантирует предложить вам лучший пакет и цену.",
		save_percentage: "Экономьте 16% ежемесячно",
	},
	$language: {
		ar: "العربية",
		de: "Deutsch",
		en: "English",
		es: "Español",
		fr: "Français",
		hi: "हिन्दी",
		ind: "Bahasa Indonesia",
		it: "Italiano",
		ja: "日本語",
		ko: "한국어",
		pt: "Português",
		ru: "Русский",
		tr: "Türkçe",
		vi: "Tiếng Việt",
		zh: "中文",
	},
	$languageLocal: {
		ar: "Арабский",
		de: "Немецкий",
		en: "Английский",
		es: "Испанский",
		fr: "Французский",
		hi: "Хинди",
		ind: "Индонезийский",
		it: "Итальянский",
		ja: "Японский",
		ko: "Корейский",
		pt: "Португальский",
		ru: "Русский",
		tr: "Турецкий",
		vi: "Вьетнамский",
		zh: "Китайский",
	},
	$message: {
		cannot_delete_verified_partner: "Вы не можете удалить проверенного партнера.",
		confirm: "Вы уверены, что хотите {function}?",
		created: "{item} создан.",
		deleted: "{item} удален.",
		edited: "{item} отредактировано.",
		error_on_view_file: "Произошла ошибка при просмотре файла.",
		file_oversize: "Размер файла должен быть не более {size}.",
		invalid: "{item} недействителен",
		migrated: "{item} перемещен. ({value})",
		process_has_been_started: "Ваш {item} был начат.",
		saved: "{item} сохранено.",
		sent: "{item} отправлен.",
		sent_email: "Электронное письмо отправлено. ({value})",
		sign_in_failed: "Электронная почта или пароль неверны",
		unsupported_file_type: "Неподдерживаемый тип файла",
		updated: "{item} обновлен.",
	},
	$pageDescriptions: {
		landing_page:
			"Antrego — комплексная платформа для экспортёров, импортёров и экспедиторов. Отслеживание отправлений в реальном времени, управление запасами, создание счетов и автоматизация документооборота. Экономьте 40% времени с цифровыми логистическими решениями. Попробуйте бесплатно!",
		stock_feature:
			"Трансформируйте управление запасами с Antrego. Управляйте инвентарём, создавайте публичные каталоги, отслеживайте партии на складах и мгновенно конвертируйте позиции в отправления. Идеально для экспортёров и производителей.",
		tracking_feature:
			"Отслеживание контейнеров и отправлений в реальном времени с Antrego. Живые обновления, автоматические уведомления, полная история статусов и видимость для всех участников. Больше никаких потерянных отправлений.",
		pdf_feature:
			"Профессиональный конструктор PDF для логистики. Создавайте кастомные счета и проформы с редактором drag-and-drop, шаблонами и автозаполнением. Создавайте впечатляющие документы за минуты.",
		benefits_feature:
			"Узнайте преимущества платформы Antrego. Централизованная панель, высокая точность, экономия времени, командная работа, снижение затрат и масштабируемость. Трансформируйте логистику уже сегодня.",
		contact:
			"Свяжитесь с Antrego — задайте вопросы, запросите демонстрацию или поддержку. Мы поможем трансформировать ваши логистические процессы.",
		sign_in:
			"Вход в Antrego — получите доступ к панели логистики для управления отправлениями, отслеживания контейнеров, создания счетов и совместной работы. Безопасный портал.",
		sign_up:
			"Регистрация в Antrego — создайте бесплатный аккаунт и начните управлять логистикой. 10 бесплатных отправлений в месяц. Кредитная карта не требуется.",
	},
	$pageTitles: {
		accept_invitation: "Принять приглашение",
		benefits_feature: "Преимущества платформы — комплексное логистическое решение",
		company_profile: "Профиль компании",
		contact: "Свяжитесь с нами — Antrego",
		home: "Главная",
		landing_page: "Управляйте всеми процессами доставки в цифровом виде",
		partners: "Партнеры",
		pdf_editor: "Редактор PDF",
		pdf_feature: "PDF-конструктор — профессиональные счета",
		product_details: "Детали Продукта",
		product_groups: "Группы продуктов",
		products: "Продукты",
		proforma_invoices: "Проформа-счета",
		shipment_details: "Детали отправки",
		shipments: "Отправки",
		sign_in: "Войти",
		sign_up: "Зарегистрироваться",
		stock_details: "Детали запаса",
		stock_feature: "Управление запасами — трансформируйте инвентарь",
		stocks: "Запасы",
		subscription: "Подписка",
		tracking_feature: "Отслеживание отправлений — мониторинг контейнеров в реальном времени",
		user_profile: "Профиль пользователя",
	},
	$partnershipStatusTooltip: {
		createdHereDescription:
			"Незарегистрированные партнеры, вы создали их профиль на нашей платформе, поэтому вы можете просматривать и редактировать их информацию.",
		createdHereTitle: "Создано здесь:",
		description: "Вы можете отслеживать статус своих отношений с партнерами. Вот различия:",
		verifiedPartnersDescription:
			"Эти партнеры приняли ваше приглашение и зарегистрировались на платформе. Их информация доступна только для просмотра и не может быть отредактирована.",
		verifiedPartnersTitle: "Проверенные партнеры:",
	},
	$productGroup: {
		add_child: "Добавить подгруппу",
		add_new_product_group: "Добавить новую группу продуктов",
		add_to_root: "Добавить в корень",
		has_children_fail_message: "Группа продуктов с дочерними элементами не может быть удалена",
		initial_message: "Используйте эту кнопку {0}, чтобы создать свою первую группу продуктов.",
		name: "Название",
		number_of_product: "Количество продуктов",
	},
	$proformaInvoice: {
		$actionDescription: {
			approve: "{name} утверждено.",
			create: "Создано {name}.",
			create_attachment: "{name} создал вложение.",
			delete_attachment: "{name} удалил вложение.",
			demand_revise: "{name} запросил пересмотр.",
			mark_as_processed: "{name} отмечено как обработано.",
			reject: "{name} отклонено.",
			revoke: "{name} отозвано.",
			send: "{name} отправлено получателю для оценки.",
			update: "Обновлено {name}.",
			update_attachment: "{name} обновил вложение.",
		},
		$actions: {
			approve: "Утвердить",
			demand_revise: "Запросить пересмотр",
			mark_as_approved: "Утверждено",
			mark_as_processed: "Обработано",
			mark_as_rejected: "Отклонено",
			mark_as_revise_demanded: "Требуется пересмотр",
			mark_as_revoked: "Отозвано",
			mark_as_sent: "Отправлено",
			reject: "Отклонить",
			revoke: "Отозвать",
			send: "Отправить",
		},
		$status: {
			approved: "Утверждено",
			pending_approval: "Ожидает утверждения",
			pending_revise: "Ожидает пересмотра",
			processed: "Обработано",
			rejected: "Отклонено",
			revoked: "Отозвано",
			template: "Шаблон",
		},
		approve_confirm_message: "Вы уверены, что хотите утвердить проформа-счет?",
		approve_success_message: "Проформа-счет был утвержден.",
		demand_revise_description_message: "Пожалуйста, укажите детали ваших ожиданий по пересмотру:",
		demand_revise_success_message: "Проформа-счет был отправлен обратно отправителю для пересмотра.",
		mark_as_processed_confirm_message: "Вы подтверждаете, что хотите отметить проформа-счет как обработанный?",
		mark_as_processed_success_message: "Проформа-счет был отмечен как обработанный.",
		no_attachment_text: "Вложений пока нет.",
		reject_confirm_message: "Вы уверены, что хотите отклонить проформа-счет?",
		reject_success_message: "Проформа-счет был отклонен.",
		revoke_confirm_message: "Вы уверены, что хотите отозвать проформа-счет?",
		revoke_success_message: "Проформа-счет был отозван.",
		send_confirm_message: "Вы подтверждаете отправку проформа-счета получателю?",
		send_success_message: "Проформа-счет был отправлен.",
	},
	$seoTitles: {
		landing_page:
			"Antrego | Программное обеспечение для управления логистикой - Отслеживайте, Управляйте, Автоматизируйте",
		stock_feature: "Программное обеспечение для управления запасами | Система отслеживания складских запасов | Antrego",
		tracking_feature:
			"Программное обеспечение для отслеживания отправлений в реальном времени | Отслеживание контейнеров | Antrego",
		pdf_feature: "Генератор проформы-счета | PDF-редактор для логистики | Antrego",
		benefits_feature: "Преимущества полной логистической платформы | Универсальное решение | Antrego",
	},
	$serviceMessage: {
		already_subs_module: "Подписка на этот модуль уже существует.",
		bad_request: "Неверный запрос",
		code_already_used: "Код уже был использован.",
		container_status_not_available: "Статус контейнера недоступен.",
		existing_email_warning: "Электронная почта уже существует.",
		existing_employee_error: "Этот пользователь уже добавлен в вашу компанию.",
		existing_employee_for_email_warning: "Код приглашения уже отправлен на этот электронный адрес",
		existing_invitation_warning: "Код приглашения уже отправлен на этот электронный адрес.",
		existing_token_already_have_time: "Существующий токен уже имеет достаточно времени для использования.",
		existing_user: "Пользователь уже существует.",
		five_min_reset_password_mail:
			"Вы должны подождать как минимум 5 минут после того, как запросите письмо для сброса пароля один раз.",
		forbidden: "Запрещено",
		have_no_corporation: "У вас нет корпорации",
		have_no_custom_agency: "У вас нет таможенного агентства",
		have_no_employee: "У вас нет сотрудников",
		instance_can_no_delete_existing_booking_code:
			"Этот экземпляр больше нельзя удалить из-за существующего кода бронирования.",
		instance_cannot_delete: "Этот экземпляр больше нельзя удалить.",
		instance_not_found: "Экземпляр не найден.",
		internal_server_error: "Внутренняя ошибка сервера",
		invalid_current_password: "Недействительный текущий пароль.",
		invalid_identifier_or_password: "Неверный идентификатор или пароль",
		invalid_invitation_code: "Код приглашения неверен.",
		invalid_moving_request: "Недействительный запрос на перемещение",
		invalid_operation: "Недопустимая операция",
		invalid_refresh_token: "Недействительный токен обновления.",
		invalid_unit: "Недопустимая единица измерения",
		invitation_accepting_is_due_to_the_admin: "Принятие приглашения зависит от администратора.",
		invitation_already_discarded: "Приглашение уже отклонено.",
		invitation_already_used: "Приглашение уже использовано.",
		invitation_has_been_used: "Приглашение было использовано.",
		invitation_not_exist_email: "Приглашение не существует на данном адресе электронной почты.",
		invitation_not_for_company: "Это приглашение не для компании.",
		invitation_not_for_custom_agency: "Это приглашение не для таможенного агентства.",
		invitation_not_found: "Приглашение не найдено.",
		invitation_not_valid: "Приглашение больше не действительно.",
		link_has_been_expired: "Ссылка истекла.",
		link_not_be_used_anymore: "Эта ссылка больше не может быть использована",
		missing_required_fields: "Отсутствуют обязательные поля.",
		no_employee_found: "Сотрудники не найдены",
		no_proper_partner_found: "Подходящий партнер не найден.",
		not_acceptable: "Неприемлемо",
		not_allowed_action: "Вам не разрешено выполнять это действие.",
		not_allowed_use_api: "Вам не разрешено использовать этот API.",
		not_found: "Не найдено",
		not_have_purchase_subscription:
			"Ваш план подписки достиг максимального лимита для добавлений. Чтобы добавить больше, рассмотрите возможность обновления вашего плана подписки.",
		not_permitted_use_api: "Вам не разрешено использовать этот API.",
		own_invitation_cannot_accept: "Вы не можете принять собственное приглашение.",
		parent_group_not_found: "Группа-родитель не найдена",
		partnerId_required: "Необходим идентификатор партнера.",
		partnership_already_exists: "Партнер уже был добавлен.",
		password_cant_involve_space_char: "Пароль не может содержать пробелы.",
		password_min_chars_least: "Пароль должен содержать не менее 6 символов.",
		payment_required: "Пожалуйста, оформите подписку для этого процесса.",
		paytr_integration_error: "Ошибка интеграции PayTR",
		ports_are_required: "Порты обязательны.",
		product_group_tree_not_found: "Дерево групп продуктов не найдено",
		proforma_invoice_action_not_available: "Статус проформа-счета недоступен для этого действия.",
		proforma_invoice_template_update: "Проформа-счет должен быть шаблоном для обновления.",
		shipment_email_not_exist: "Пожалуйста, введите действительный электронный адрес.",
		shipment_method_is_required: "Требуется метод доставки.",
		shipping_term_is_required: "Требуется условие доставки.",
		someone_else_uses_this_email: "Кто-то другой использует этот электронный адрес.",
		someone_else_uses_this_username: "Кто-то другой использует это имя пользователя.",
		something_went_wrong: "Что-то пошло не так",
		type_can_be_abstract_company: 'Свойство "тип" может быть только "abstract_company"',
		unauthorized: "Неавторизован",
		undefined_result: "Неопределенный результат",
		unexpected_error_occurred: "Произошла неожиданная ошибка",
		unit_already_added: "Единица измерения уже добавлена.",
		user_already_employee: "Пользователь уже является сотрудником.",
		user_already_exists: "Пользователь уже существует в компании.",
		user_does_not_exist: "Пользователь не существует.",
		user_not_found: "Пользователь не найден.",
		username_min_chars_error: "Имя пользователя должно содержать не менее 6 символов.",
	},
	$shipment: {
		$actionDescription: {
			$land: {
				create_container: "{name} добавил транспортное средство.",
				delete_container: "{name} удалил транспортное средство.",
				update_container: "{name} обновил транспортное средство.",
			},
			create: "Создано {name}.",
			create_attachment: "{name} добавил вложение.",
			create_container: "{name} добавил контейнер.",
			delete_attachment: "{name} удалил вложение.",
			delete_container: "{name} удалил контейнер.",
			update: "Обновлено {name}.",
			update_attachment: "{name} обновил вложение.",
			update_container: "{name} обновил контейнер.",
		},
		$containerStatus: {
			arrived: "Прибыл",
			off_load: "На разгрузке",
			on_load: "На загрузке",
			on_way: "В пути",
			reserved: "Зарезервировано",
		},
		$method: {
			aerial: "Воздушный",
			land: "Наземный",
			railway: "Железнодорожный",
			sea: "Морской",
		},
		$vehicle: {
			license_number: "Номерной знак",
		},
		archiving_success_message: "Отправка была архивирована.",
		leave_message: "Оставьте свое сообщение или комментарий",
		no_booking_info: "Информация о бронировании еще не установлена. Используйте кнопку {0}, чтобы добавить.",
		no_transportation_info:
			"Информация о транспортировке еще не установлена. Используйте кнопку {0}, чтобы установить.",
		un_archiving_success_message: "Отправка была разархивирована.",
	},
	$shortening: {
		number: "№",
	},
	$socialMedia: {
		facebook: "Facebook",
		instagram: "Instagram",
		linked_in: "LinkedIn",
		twitter: "Twitter",
	},
	$subscription: {
		$message: {
			check_your_payment_method: "Не удалось продлить вашу подписку. Пожалуйста, проверьте ваш способ оплаты.",
			fail: "Произошла неожиданная ошибка. Пожалуйста, попробуйте позже. Если проблема не исчезнет, ​​сообщите, отправив письмо на info@antrego.net.",
			ok: "Процесс покупки был начат. Результат процесса будет уведомлен по электронной почте. Ваша подписка начнется, когда оплата будет успешно завершена.",
			payment_process_is_ongoing:
				"Ваш процесс оплаты продолжается. Результат процесса будет уведомлен по электронной почте. Ваша подписка начнется, когда оплата будет успешно завершена.",
			success: "Ваша подписка была успешно создана. Вы можете начать легко использовать Antrego.",
			try_to_get_paid_again: "Ваша подписка истекла. Нажмите здесь, чтобы продлить.",
			unsubscribed: "Отменена подписка",
			you_dont_have_any_subscription:
				"У вас нет подписки. Пожалуйста, выберите пакет на странице подписки и начните использовать его легко.",
			you_dont_have_any_subscription_text: "Выберите план, чтобы продолжить.",
			you_dont_have_any_subscription_title: "У вас нет активной подписки.",
		},
	},
	$unit: {
		acres: "Акры",
		boxes: "Коробки",
		centimeter: "Сантиметр",
		cubic_meter: "Кубический метр",
		dozen: "Дюжины",
		feet: "Футы",
		fluid_ounces: "Жидкие унции",
		gallons: "Галлоны",
		gram: "Грамм",
		hectare: "Гектар",
		inches: "Дюймы",
		kilogram: "Килограмм",
		kilometer: "Километр",
		liter: "Литр",
		meter: "Метр",
		miles: "Мили",
		milligram: "Миллиграмм",
		milliliter: "Миллилитр",
		millimeter: "Миллиметр",
		ounces: "Унции",
		pallets: "Паллеты",
		pieces: "Штуки",
		pounds: "Фунты",
		quarts: "Кварты",
		square_feet: "Квадратные футы",
		square_inches: "Квадратные дюймы",
		square_kilometer: "Квадратный километр",
		square_meter: "Квадратный метр",
		square_miles: "Квадратные мили",
		square_yards: "Квадратные ярды",
		ton: "Тонны",
		yards: "Ярды",
	},
	$validation: {
		email: "Пожалуйста, введите действующий электронный адрес",
		invalid: "{item} недействителен",
		max_length: "{item} должен быть меньше {length} символов",
		min_length: "{item} должен быть больше {length} символов",
		must_length: "{item} должен быть {length} символов",
		only_number: "{item} должен быть числом",
		password_repeat_warning: "Повтор пароля не совпадает с новым паролем.",
		required: "{item} обязателен",
		required_for_default_language: "{item} обязателен для языка по умолчанию компании.",
		you_must_approve_distance_sales_agreement: "Вы должны одобрить договор дистанционной продажи",
	},
	about: "О нас",
	accept_invitation: "Принять приглашение",
	accept_invitation_success_message: "Вы успешно использовали приглашение.",
	accessibility: "доступность",
	actions: "Действия",
	active: "Активен",
	activities: "Деятельность",
	add: "Добавить",
	add_attribute: "Добавить Атрибут",
	add_from_stock: "Добавить из запаса",
	add_images: "Добавить изображение",
	add_item: "Добавить {item}",
	add_manually: "Создать здесь",
	add_new_employee: "Добавить нового сотрудника",
	add_new_packaging: "Добавить новую упаковку",
	add_new_product: "Добавить новый продукт",
	add_new_stock: "Добавить новый запас",
	add_new_warehouse: "Добавить новый склад",
	add_stock_batch: "Добавить партию запасов",
	add_template: "Добавить шаблон",
	add_variant: "Добавить Вариант",
	address: "Адрес",
	again: "Снова",
	alert: "Предупреждение",
	already_have_employee_message: "Вы уже являетесь сотрудником компании.",
	amount: "Сумма",
	approve: "Утвердить",
	archive: "Архивировать",
	attachment: "Вложение",
	attachments: "Вложения",
	attribute: "Атрибут",
	attributes: "Атрибуты",
	auto_attached_pdf: "PDF автоматически добавлен",
	auto_detect: "Автоопределение",
	available: "Доступно",
	bank: "Банк",
	basket: "Корзина",
	basket_empty: "Ваша корзина пуста",
	batch: "Партия",
	batch_no: "Номер партии",
	batches: "Партии Запасов",
	benefits: "Преимущества",
	billed_to: "Выставлен счет на",
	booking: "Бронирование",
	booking_code: "Код бронирования",
	booking_details: "Детали бронирования",
	boolean: "Булевый",
	business_partner: "Коммерческий партнер",
	business_partners: "Коммерческие партнеры",
	cancel: "Отмена",
	carrier: "Перевозчик",
	change_password: "Сменить пароль",
	checking_invitation_code_message: "Проверка кода приглашения",
	checkout: "Оформить заказ",
	choose_image: "Выбрать изображение",
	choose_your_plan: "Выберите свой план",
	clear: "Очистить",
	clear_basket: "Очистить Корзину",
	click_to_play_the_video: "Нажмите, чтобы воспроизвести видео",
	close: "Закрыть",
	code: "Код",
	commercial: "Коммерческий",
	commercial_partner: "Коммерческий партнер",
	commercial_partners: "Коммерческие партнеры",
	companies: "Компании",
	company: "Компания",
	company_address: "Адрес компании",
	company_name: "Название компании",
	company_profile: "Профиль компании",
	configuration: "Конфигурация",
	confirm: "Подтвердить",
	confirm_distance_selling_agreement: "Подтвердите договор дистанционной продажи.",
	consult_us: "Консультируйтесь с нами",
	contact: "Контакт",
	contact_info: "Контактная информация",
	contact_text: "Не беспокойтесь, мы свяжемся с вами как можно скорее.",
	contact_title: "Свяжитесь с нами, упростите свои процессы",
	contact_to_us: "Свяжитесь с нами",
	container: "Контейнер",
	container_no: "Номер контейнера",
	containers: "Контейнеры",
	content: "Содержание",
	contract: "Контракт",
	copy_link: "Копировать ссылку",
	corporation: "Компания",
	countries: "Страны",
	country: "Страна",
	create: "Создать",
	create_a_new_account: "Создать новую учетную запись",
	create_company: "Создать компанию",
	create_document: "Создать документ",
	create_shipment: "Создать отправку",
	created_at: "Создано в",
	created_here: "Создано здесь",
	credit_card_info: "Информация о кредитной карте",
	credit_card_no: "Номер кредитной карты",
	currencies: "Валюты",
	currency: "Валюта",
	current_password: "Текущий пароль",
	current_plan: "Текущий план",
	customer_company_address: "Адрес компании клиента",
	customer_company_name: "Название компании клиента",
	customs: "Таможня",
	customs_agencies: "Таможенные агентства",
	customs_agency: "Таможенное агентство",
	cvv: "CVV",
	daily: "Ежедневно",
	damaged: "Повреждено",
	dashboard: "Панель управления",
	date: "Дата",
	date_input: "Ввод даты",
	day: "День",
	default: "По умолчанию",
	default_language: "Язык по умолчанию",
	delete: "Удалить",
	delete_account: "Удалить аккаунт",
	delete_confirm_message: "Вы подтверждаете удаление?",
	delete_document: "Удалить документ",
	delete_template: "Удалить шаблон",
	description: "Описание",
	detail: "Детали",
	dimensions: "Размеры",
	discard: "Отменить",
	discover_all_benefits: "Откройте все преимущества",
	distance_sales_agreement: "Договор дистанционной продажи",
	document: "Документ",
	document_actions: "Действия с документами",
	document_added: "Документ добавлен",
	document_creator: "Генератор документов",
	document_manager: "Менеджер документов",
	document_name: "Имя документа",
	document_number: "Номер документа",
	document_overwrite: "Сохранить изменения как новый документ",
	document_save_info: "Этот документ будет сохранен только в этом счете-проформе.",
	document_updated: "Документ обновлен",
	download: "Загрузить",
	download_pdf: "Скачать PDF",
	download_template: "Скачать шаблон",
	edit: "Редактировать",
	edit_attribute: "Редактировать атрибут",
	edit_description: "Редактировать описание",
	edit_document: "Редактировать документ",
	edit_item: "Редактировать {item}",
	edit_packaging: "Редактировать упаковку",
	edit_product: "Редактировать продукт",
	edit_profile: "Редактировать профиль",
	edit_stock: "Редактировать запас",
	edit_stock_batch: "Редактировать партию запасов",
	edit_template: "Редактировать шаблон",
	edit_variant: "Редактировать Вариант",
	edit_your_profile_picture: "Изменить фото профиля",
	email: "Электронная почта",
	employee: "Сотрудник",
	employee_type: "Тип сотрудника",
	employees: "Сотрудники",
	empty_data_warning:
		"В этой области еще нет данных. Вы можете начать исследовать платформу с помощью примерных данных.",
	estimated_arrival_day: "Ожидаемый день прибытия",
	expense: "Расход",
	expenses: "Расходы",
	expires_at: "Истекает",
	explore_pdf_editor: "Создавайте документы мгновенно",
	explore_stock_management: "Освойте управление запасами",
	explore_tracking_features: "Отслеживайте в реальном времени",
	exported_containers: "Экспортированные контейнеры",
	fail: "Неудача",
	failed: "Не удалось",
	faq: "Часто задаваемые вопросы",
	feedback: "Обратная связь",
	file: "Файл",
	file_name: "Имя файла",
	file_preview: "Предварительный просмотр файла",
	file_processing_error_message: "Ошибка обработки файла: {error}",
	file_read_error_message: "Ошибка чтения файла",
	file_view: "Просмотр файла",
	filter: "Фильтр",
	first_name: "Имя",
	first_name_last_name: "Имя Фамилия",
	fixed_value: "Постоянное значение",
	forget_password: "Забыли пароль",
	forget_password_message: "Забыли свой пароль?",
	forget_password_subtitle: "Пожалуйста, введите свой адрес электронной почты, чтобы сбросить пароль.",
	format: "Формат",
	free: "Бесплатно",
	from: "От",
	general: "По умолчанию",
	get_started_now: "Начните сейчас",
	give_us_feedback: "Оставьте нам отзыв",
	go_to_panel: "Перейти к панели управления",
	go_to_proforma: "Перейти к проформе",
	go_to_shipment: "Перейти к отправке",
	gross: "Брутто",
	height: "Высота",
	hide: "Скрыть",
	hide_all: "Скрыть всё",
	home_page: "Главная страница",
	i_have_invitation_code: "У меня есть код приглашения",
	image_delete: "Удалить изображение",
	images: "Изображения",
	import_excel: "Импорт из Excel",
	import_fail_message: "Импорт не выполнен: {error}",
	import_success_message: "Успешно импортировано {count} продуктов{skipped}.",
	imported_containers: "Импортированные контейнеры",
	in_progress: "В процессе",
	in_stock: "В Наличии",
	incoming: "Входящие",
	incoming_shipments: "Входящие отправки",
	initial: "Первоначальный",
	inputs: "Содержимое",
	invitation: "Приглашение",
	invitation_code: "Код приглашения",
	invitation_mail_sent: "Письмо с приглашением отправлено",
	invitations: "Приглашения",
	invoice: "Счёт",
	invoice_no: "Номер счета",
	join: "Присоединиться",
	join_company: "Присоединиться к компании",
	language: "Язык",
	language_options: "Языковые настройки",
	last_name: "Фамилия",
	last_one_year: "Последний 1 год",
	latitude: "Широта",
	learn_more: "Узнать больше",
	left_a_comment: "Оставил комментарий",
	length: "Длина",
	link_copied: "Ссылка скопирована",
	link_copy_failed: "Не удалось скопировать ссылку",
	loading_country: "Страна загрузки",
	loading_point: "Точка загрузки",
	loading_port: "Порт загрузки",
	log_in: "Войти",
	logo: "Логотип",
	longitude: "Долгота",
	lot_no: "Номер партии",
	mail_sent: "Электронное письмо отправлено",
	make_visible: "Сделать видимым",
	manage_profile: "Управление профилем",
	mass: "Масса",
	measurements: "Измерения",
	merge_partner_description:
		"Компания, созданная здесь, может быть объединена с существующим проверенным партнером, когда она создаст профиль в Antrego.",
	message: "Сообщение",
	message_company_create: "Компания создана.",
	message_company_join: "Пожалуйста, введите код приглашения.",
	message_company_joined: "Вы присоединились к компании",
	message_employee_delete: "Сотрудник удален.",
	message_employee_save: "Сотрудник сохранен.",
	message_join_company: "Введите код, чтобы присоединиться к существующей компании",
	method: "Метод",
	migrate: "Мигрировать",
	migrate_partner: "Мигрировать компанию",
	migrate_partner_description:
		"Созданную здесь компанию можно объединить с существующим проверенным партнером, когда он создаст профиль на Antrego.",
	missing_product_group_sheet_message: "Отсутствует лист группы продуктов в Excel файле",
	missing_product_sheet_message: "Отсутствует лист продукта в Excel файле",
	mobile_number: "Мобильный номер",
	month: "Месяц",
	month_lowercase: "месяц",
	monthly: "Ежемесячно",
	multiple_select: "Множественный Выбор",
	my_profile: "Мой профиль",
	my_role: "Моя роль",
	name: "Имя",
	net: "Нетто",
	new: "Новый",
	new_company_package: "Бесплатно",
	new_password: "Новый пароль",
	new_shipment: "Новая поставка",
	next: "Следующий",
	no: "Нет",
	no_content: "Нет содержимого",
	no_entity: "Нет сущностей",
	no_entity_message: "Сущности не найдены.",
	no_image: "Изображение не найдено",
	no_product_data_message: "Данные о продукте в Excel файле не найдены",
	no_product_group_data_message: "Данные о группе продуктов в Excel файле не найдены",
	no_stock_batches_found: "Партии на складе не найдены",
	no_stock_matches_filters: "Нет запасов, соответствующих выбранным фильтрам.",
	no_stocks_added_yet: "Запасы ещё не добавлены — пожалуйста, выберите или добавьте один.",
	no_text: "Нет текста",
	no_valid_products_message:
		"Подходящие продукты не найдены. Все продукты должны иметь название на языке по умолчанию ({language}).",
	not_found_in_stock: "Не удалось найти товар на складе по текущим фильтрам.",
	not_found_page_message: "Извините, не могу найти эту страницу :(",
	not_set: "Не установлено",
	note: "Заметка",
	notes: "Заметки",
	number_of_rows: "Количество строк",
	ok: "OK",
	operation_fail: "Неудача операции",
	option: "Опция",
	options: "Опции",
	other: "Другое",
	out_of_stock: "Нет В Наличии",
	outgoing: "Исходящие",
	outgoing_shipments: "Исходящие отправки",
	packages: "Пакеты",
	packaging: "Упаковка",
	packing_list_title: "Упаковочный лист",
	parent_group: "Родительская группа",
	partner: "Партнер",
	partners: "Партнеры",
	partnership_status: "Статус партнерства",
	passive: "Пассивный",
	password: "Пароль",
	pay: "Оплатить",
	payback: "Возврат",
	payback_confirm_message: "Вы подтверждаете возврат?",
	payback_warning_message: "Если вы продолжите, ваша подписка будет прекращена.",
	payment: "Оплата",
	payment_amount: "Сумма оплаты",
	payment_awaited: "Ожидается оплата",
	payment_history: "История платежей",
	payment_info: "Платежная информация",
	payment_information: "Платежная информация",
	payment_success: "Оплата успешно завершена",
	payment_summary: "Сводка платежей",
	payment_will_be_made_3d_secure: "*Ваш платеж будет произведен с использованием 3D Secure.",
	pdf_attached_message: "PDF успешно добавлен",
	pdf_editor: "Редактор PDF",
	pdf_name: "Имя PDF",
	pending_invitations: "Ожидающие приглашения",
	per_month: "В месяц",
	phone_number: "Номер телефона",
	pieces: "Штуки",
	plate_numbers: "Номера автомобилей",
	please_click_add_option: "Вы ввели вариант, но не добавили его. Пожалуйста, добавьте или удалите его.",
	prefix: "Префикс",
	premium: "Премиум",
	premium_plus: "Премиум Плюс",
	preview: "Предпросмотр",
	previous: "Предыдущий",
	price: "Цена",
	pricing: "Цены",
	process: "Процесс",
	product: "Продукт",
	product_details: "Детали Продукта",
	product_group: "Группа продуктов",
	product_group_name: "Название группы продуктов",
	product_group_not_found_message: 'Группа продуктов "{group}" не найдена. Продукт с кодом "{code}" пропущен.',
	product_groups: "Группы продуктов",
	product_images: "Изображения товара",
	product_name: "Название продукта",
	products: "Продукты",
	profile: "Профиль",
	proforma_invoice: "Проформа-счет",
	proforma_invoices: "Проформа-счета",
	proforma_number: "Номер проформа-счета",
	proforma_options: "Параметры Проформы",
	proforma_title: "Счёт-проформа",
	purchase: "Покупка",
	quantity: "Количество",
	quantity_warning:
		"Так как вы ранее изменили значение общего запаса, итог больше не будет рассчитываться автоматически.",
	ready_to_import: "Готово к импорту",
	receiver: "Получатель",
	receiver_company: "Компания получателя",
	receiver_customs_agency: "Таможенное агентство получателя",
	redirection_to_home_link: "Главная",
	redirection_to_home_message: "Вы также можете перейти на ",
	redirection_to_sign_in_message: "Уже есть аккаунт?",
	redirection_to_sign_up_message: "Еще нет аккаунта?",
	reload: "Перезагрузить",
	renewal: "Продление",
	repaid: "Возвращено",
	reserved: "Зарезервировано",
	reset_password: "Сброс пароля",
	returned: "Возвращено",
	route: "Маршрут",
	rows_per_page: "Строк на страницу",
	sales: "Продажи",
	save: "Сохранить",
	save_as_document: "Сохранить как документ",
	save_as_new_document: "Сохранить как новый документ",
	save_as_new_template: "Сохранить как новый шаблон",
	save_as_template: "Сохранить как шаблон",
	save_changes: "Сохранить изменения",
	save_pdf_to_attachments: "Сохранить PDF во вложения",
	saved_card_info: "Сохраненная информация о карте",
	search: "Поиск",
	select: "Выбрать",
	select_a_file_to_preview: "Выберите файл для предварительного просмотра",
	select_document: "Выберите документ",
	select_document_to_overwrite: "Выбрать документ для перезаписи",
	select_file: "Выбрать файл",
	select_file_place_holder: "Пожалуйста, выберите изображение",
	select_language: "Выбрать язык",
	select_template: "Выберите шаблон",
	select_template_to_overwrite: "Выбрать шаблон для перезаписи",
	selected: "Выбрано",
	selected_partner: "Выбранный партнер",
	send: "Отправить",
	send_again: "Отправить снова",
	send_email: "Отправить электронное письмо",
	send_feedback: "Отправить отзыв",
	send_invitation: "Отправить приглашение",
	sender: "Отправитель",
	sender_company: "Компания отправителя",
	sender_customs_agency: "Таможенное агентство отправителя",
	separate_gross: "Добавить брутто-измерения",
	settings: "Настройки",
	shipment: "Отправка",
	shipment_code: "Код отправки",
	shipment_details: "Детали отправки",
	shipment_method: "Метод отправки",
	shipment_type: "Тип отправки",
	shipments: "Отправки",
	shipments_filter: "Фильтр отправок",
	shipped: "Отправлено",
	shipping_term: "Условия доставки",
	shipping_terms: "Условия доставки",
	show: "Показать",
	show_all: "Показать всё",
	show_company_stock_page: "Показать страницу запасов компании",
	show_in_stocks: "Показать на странице склада",
	sign_in: "Войти",
	sign_out: "Выйти",
	sign_out_confirm_message: "Вы подтверждаете выход?",
	sign_out_success_message: "До свидания.",
	sign_up: "Зарегистрироваться",
	sizes: "Размеры",
	social_media: "Социальные сети",
	social_media_account: "Аккаунт в социальных сетях",
	start_time: "Время начала",
	status: "Статус",
	stock: "Склад",
	stock_details: "Детали запаса",
	stock_images: "Изображения запаса",
	stock_status: "Статус Запаса",
	stocks: "Запасы",
	stocks_url: "Ссылка на склад",
	subscribe: "Подписаться",
	subscription: "Подписка",
	subscription_info_message: "Вы можете пользоваться всеми услугами неограниченно в течение периода подписки.",
	subscription_warning_message:
		"**Информация о вашей карте будет надежно сохранена, и ваша подписка будет регулярно продлеваться, если вы не отмените ее.",
	success: "Успех",
	super: "Супер",
	supported_files_img: "Поддерживаемые файлы: JPG, PNG.",
	switch_language: "Сменить язык",
	switch_theme: "Сменить тему",
	table_inputs: "Содержимое таблицы",
	target: "Цель",
	target_partner: "Целевой партнер",
	tax_number: "Налоговый номер",
	template: "Шаблон",
	template_actions: "Действия с шаблонами",
	template_added: "Шаблон добавлен",
	template_name: "Название шаблона",
	template_overwrite: "Сохранить изменения как новый шаблон",
	template_save_info: "Сохраненные шаблоны позже будут доступны для использования в счетах-проформе и отправках.",
	template_updated: "Шаблон обновлен",
	terms_of_sale_and_other_comments: "Условия продажи - Комментарии",
	text_input: "Текстовый ввод",
	theme: "Тема",
	this_month: "Этот месяц",
	this_year: "Этот год",
	title: "Заголовок",
	to: "К",
	toDelete: "Удалить",
	total: "Всего",
	total_amount: "Общая сумма",
	total_price: "Итоговая цена",
	total_warning: "Если вы измените эти данные, итог больше не будет рассчитываться автоматически.",
	tracking: "Отслеживание отправлений",
	transaction_no: "Номер транзакции",
	transactions: "Транзакции",
	try_for_free: "Попробуйте бесплатно",
	type: "Тип",
	types: "Типы",
	un_archive: "Разархивировать",
	unit: "Единица",
	unit_price: "Цена за единицу",
	units: "Единицы",
	unloading_country: "Страна разгрузки",
	unloading_point: "Точка разгрузки",
	unloading_port: "Порт разгрузки",
	unsubscribe: "Отписаться",
	unsubscribe_confirm_message:
		"Если вы отпишетесь, вы не сможете эффективно использовать функции системы. Вы уверены, что хотите отписаться?",
	upload_new_image: "Загрузить новое изображение",
	use_code: "Использовать код",
	use_invitation_code: "Использовать код приглашения",
	use_invitation_code_description: "Введите свой код приглашения, отправленный на вашу почту.",
	use_invitation_code_success_message: "Код приглашения был успешно использован.",
	user_profile: "Мой профиль",
	value: "Значение",
	variant: "Вариант",
	variants: "Варианты",
	vehicle: "Транспортное средство",
	vehicles: "Транспортные средства",
	verified_partner: "Проверенный партнер",
	verify_password: "Подтвердите пароль",
	visibility: "Видимость",
	warehouse: "Склад",
	warehouses: "Склады",
	warn_unsaved_measurement: "Не забудьте нажать «+», чтобы добавить ваши замеры.",
	website: "Вебсайт",
	week: "Неделя",
	weight: "Вес",
	weight_kg: "Вес (кг)",
	welcome: "Добро пожаловать",
	what_we_are_doing: "Что мы делаем",
	width: "Ширина",
	year: "Год",
	year_lowercase: "год",
	yearly: "Ежегодно",
	yes: "Да",
	yes_no: "Да / Нет",
	you_dont_have_any_active_subscription: "У вас нет активной подписки",
};
